<!-- user-management.component.html -->
<div class="container">
  <form [formGroup]="userForm" (ngSubmit)="addOrUpdateUser()" class="user-form">
    <mat-form-field appearance="fill" class="form-field">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" placeholder="Enter username" />
      <mat-error *ngIf="userForm.get('username')?.hasError('required')">
        Username is required
      </mat-error>
      <mat-error *ngIf="userForm.get('username')?.hasError('minlength')">
        Username must be at least 3 characters
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-field">
      <mat-label>Password</mat-label>
      <input matInput [type]="showPassword?'text':'password'" formControlName="password" placeholder="Enter password" />
      <mat-error *ngIf="userForm.get('password')?.hasError('required')">
        Password is required
      </mat-error>
      <mat-error *ngIf="userForm.get('password')?.hasError('minlength')">
        Password must be at least 6 characters
      </mat-error>
    </mat-form-field>

    <mat-checkbox
      class="example-margin"
      [checked]="showPassword"
      (change)="showPassword=$event.checked"
    >
      Show Password
    </mat-checkbox>

    <mat-form-field appearance="fill" class="form-field">
      <mat-label>Role</mat-label>
      <mat-select formControlName="userrole">
        <mat-option *ngFor="let role of roles" [value]="role">{{ role }}</mat-option>
      </mat-select>
      <mat-error *ngIf="userForm.get('userrole')?.hasError('required')">
        Role is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-field">
      <mat-label>Church ID</mat-label>
      <mat-select formControlName="church_id">
        <mat-option *ngFor="let churchId of churchIds" [value]="churchId">{{ churchId }}</mat-option>
      </mat-select>
      <mat-error *ngIf="userForm.get('church_id')?.hasError('required')">
        Church ID is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-field" *ngIf="editIndex !== null">
      <mat-label>Account Status</mat-label>
      <mat-select formControlName="account_locked">
        <mat-option [value]="false">Unlocked</mat-option>
        <mat-option [value]="true">Locked</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" type="submit">
      {{ editIndex !== null ? 'Update User' : 'Add User' }}
    </button>
    <button mat-raised-button color="warn" type="button" (click)="resetForm()" *ngIf="editIndex !== null">
      Cancel
    </button>
  </form>

  <table mat-table [dataSource]="users" class="user-table">
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef>Username</th>
      <td mat-cell *matCellDef="let user">{{ user.username }}</td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let user">{{ user.userrole }}</td>
    </ng-container>

    <ng-container matColumnDef="churchId">
      <th mat-header-cell *matHeaderCellDef>Church ID</th>
      <td mat-cell *matCellDef="let user">{{ user.church_id }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let user">
        <span [class.locked]="user.account_locked" [class.unlocked]="!user.account_locked">
          {{ user.account_locked ? 'Locked' : 'Unlocked' }}
        </span>
        <span *ngIf="user.locked_until && user.account_locked" class="lock-time">
          (Until {{ user.locked_until | date:'medium' }})
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let user; let i = index">
        <button mat-icon-button color="primary" (click)="editUser(i)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="deleteUser(user)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['username', 'role', 'churchId', 'status', 'actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['username', 'role', 'churchId', 'status', 'actions']"></tr>
  </table>
</div>
